import { render, staticRenderFns } from "./OrderPropertyListItem.vue?vue&type=template&id=6fc17f6c&"
import script from "./OrderPropertyListItem.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/9735/119/casaPadrino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc17f6c')) {
      api.createRecord('6fc17f6c', component.options)
    } else {
      api.reload('6fc17f6c', component.options)
    }
    module.hot.accept("./OrderPropertyListItem.vue?vue&type=template&id=6fc17f6c&", function () {
      api.rerender('6fc17f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/OrderPropertyListItem.vue"
export default component.exports